/* Muralora made-to-measure ordering. Prices from Shopify are integer cents. */
(function () {
  'use strict';

  function sizing(widthCm, heightCm, unitPrice) {
    var valid = Number.isFinite(widthCm) && Number.isFinite(heightCm) &&
      widthCm >= 100 && widthCm <= 600 && heightCm >= 100 && heightCm <= 400 &&
      Number.isInteger(unitPrice) && unitPrice > 0;
    var area = widthCm * heightCm / 10000;
    var units = valid ? Math.max(1, Math.ceil(area - 1e-9)) : 0;
    return { valid: valid, area: area, units: units, total: units * unitPrice };
  }
  function centimeters(value, unit) {
    return Math.round(Number(value) * (unit === 'in' ? 2.54 : 1) * 100) / 100;
  }
  function dimension(value) {
    return Number(value.toFixed(4)).toString();
  }
  // Allows deterministic boundary tests without a browser or a network request.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { sizing: sizing, centimeters: centimeters, dimension: dimension };
  }
  if (typeof document === 'undefined') return;
  var root = document.querySelector('.ema-cfg');
  if (!root) return;
  var byId = function (id) { return root.querySelector('#' + id); };
  var params = new URLSearchParams(window.location.search);
  var handle = params.get('product');
  var requestedVariant = params.get('variant');
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var money = function (cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
  };
  var state = { unit: 'cm', width: 100, height: 100, unitPrice: 0, selected: null,
    productId: null, handle: handle, cropper: null, busy: false };
  var addButton = byId('emaAdd');
  addButton.disabled = true;
  if (!handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) {
    byId('emaCfgLoading').textContent = 'Choose a mural from our collection to start designing your wall.';
    return;
  }

  function synchronizeVariantLink() {
    var back = '/products/' + state.handle + '?variant=' + state.selected;
    byId('emaCfgBack').href = back;
    var current = new URL(window.location.href);
    current.searchParams.set('variant', String(state.selected));
    window.history.replaceState(null, '', current);
  }

  fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
    .then(init)
    .catch(function () { byId('emaCfgLoading').textContent = 'We could not load this mural. Please return to the product page or contact info@muralora.com.'; });

  function init(product) {
    byId('emaCfgTitle').textContent = product.title;
    state.productId = product.id;
    state.handle = product.handle;
    var variants = product.variants || [];
    var selected = variants.find(function (variant) { return String(variant.id) === requestedVariant; }) ||
      variants.find(function (variant) { return variant.available; }) || variants[0];
    if (!selected) throw new Error('No finish available');
    state.selected = selected.id;
    state.unitPrice = selected.price;
    state.available = selected.available;
    synchronizeVariantLink();
    var papers = byId('emaPapers');
    papers.replaceChildren();
    variants.forEach(function (variant) {
      var label = document.createElement('label');
      label.className = 'ema-paper' + (variant.id === state.selected ? ' sel' : '');
      var input = document.createElement('input');
      input.type = 'radio'; input.name = 'emaPaper'; input.value = String(variant.id);
      input.checked = variant.id === state.selected; input.disabled = !variant.available;
      var top = document.createElement('span'); top.className = 'ema-paper__top';
      var name = document.createElement('span'); name.className = 'ema-paper__name';
      name.textContent = variant.title.split('(')[0].trim();
      var price = document.createElement('span'); price.className = 'ema-paper__price';
      price.textContent = money(variant.price) + '/m²' + (variant.available ? '' : ' · Unavailable');
      top.append(name, price); label.append(input, top);
      input.addEventListener('change', function () {
        state.selected = variant.id; state.unitPrice = variant.price; state.available = variant.available;
        papers.querySelectorAll('.ema-paper').forEach(function (item) { item.classList.remove('sel'); });
        label.classList.add('sel'); synchronizeVariantLink(); updatePrice(false);
      });
      papers.appendChild(label);
    });

    bindControls();
    updatePrice(false);
    var images = product.images || [];
    var source = images.length ? images[images.length - 1] : product.featured_image;
    if (!source) throw new Error('Artwork missing');
    var image = byId('emaCropImg');
    image.onerror = function () { byId('emaCfgLoading').textContent = 'The artwork could not load. Please try again or contact info@muralora.com.'; };
    image.onload = function () {
      image.width = image.naturalWidth; image.height = image.naturalHeight;
      byId('emaCfgLoading').hidden = true;
      byId('emaCfgMain').style.display = 'block';
      startCropper(image);
    };
    var imageUrl = new URL(source, window.location.origin);
    imageUrl.searchParams.set('width', '1600');
    image.src = imageUrl.href;
  }

  function startCropper(image) {
    var attempts = 0;
    function ready() {
      if (!window.Cropper) {
        if (++attempts < 80) { window.setTimeout(ready, 150); return; }
        byId('emaErr').textContent = 'The design tool could not load. Please reload or contact info@muralora.com.';
        return;
      }
      state.cropper = new window.Cropper(image, {
        viewMode: 1, autoCropArea: 1, movable: false, zoomable: false,
        zoomOnTouch: false, zoomOnWheel: false, rotatable: false, scalable: true,
        dragMode: 'move', cropBoxResizable: false, cropBoxMovable: true,
        ready: function () { updatePrice(true); positionLabels(); },
        crop: positionLabels
      });
    }
    ready();
  }

  function bindControls() {
    [byId('emaW'), byId('emaH')].forEach(function (input) {
      input.addEventListener('input', function () {
        state.width = centimeters(byId('emaW').value, state.unit);
        state.height = centimeters(byId('emaH').value, state.unit);
        updatePrice(true);
      });
    });
    byId('emaCm').addEventListener('click', function () { setUnit('cm'); });
    byId('emaIn').addEventListener('click', function () { setUnit('in'); });
    byId('emaMirror').addEventListener('change', function () { if (state.cropper) state.cropper.scaleX(this.checked ? -1 : 1); });
    addButton.addEventListener('click', addToCart);
    window.addEventListener('resize', positionLabels);
  }

  function setUnit(unit) {
    if (unit === state.unit) return;
    state.unit = unit;
    var divisor = unit === 'in' ? 2.54 : 1;
    byId('emaW').value = dimension(state.width / divisor);
    byId('emaH').value = dimension(state.height / divisor);
    byId('emaW').min = dimension(100 / divisor); byId('emaW').max = dimension(600 / divisor);
    byId('emaH').min = dimension(100 / divisor); byId('emaH').max = dimension(400 / divisor);
    ['cm', 'in'].forEach(function (value) {
      var button = byId(value === 'cm' ? 'emaCm' : 'emaIn');
      button.classList.toggle('active', value === unit);
      button.setAttribute('aria-pressed', String(value === unit));
    });
    byId('emaWU').textContent = unit; byId('emaHU').textContent = unit;
    byId('emaMargin').textContent = unit === 'cm' ?
      'Add a 5–10 cm fitting margin within the supported dimensions (width 100–600 cm; height 100–400 cm).' :
      'Add a 2–4 in fitting margin within the supported dimensions (width 39.37–236.22 in; height 39.37–157.48 in).';
    updatePrice(false);
  }

  function updatePrice(resizeCrop) {
    var result = sizing(state.width, state.height, state.unitPrice);
    var error = byId('emaErr');
    if (!state.busy) error.textContent = result.valid ? '' : 'Enter a width of 100–600 cm and a height of 100–400 cm (or the equivalent in inches).';
    addButton.disabled = state.busy || !result.valid || !state.cropper || !state.available;
    root.querySelectorAll('.emaPrice').forEach(function (element) { element.textContent = result.valid ? money(result.total) : '—'; });
    var divisor = state.unit === 'in' ? 2.54 : 1;
    var width = dimension(state.width / divisor), height = dimension(state.height / divisor);
    byId('emaPMeta').textContent = result.valid ?
      width + ' × ' + height + ' ' + state.unit + ' · measured ' + Number(result.area.toFixed(4)) + ' m² · billed ' + result.units + ' m² at ' + money(state.unitPrice) + '/m²' : 'Check your wall dimensions';
    byId('emaRTop').textContent = width + ' ' + state.unit;
    byId('emaRRight').querySelector('span').textContent = height + ' ' + state.unit;
    if (resizeCrop && result.valid && state.cropper) {
      state.cropper.setAspectRatio(state.width / state.height);
      var container = state.cropper.getContainerData();
      var cropWidth = Math.min(container.width, container.height * state.width / state.height);
      var cropHeight = cropWidth * state.height / state.width;
      state.cropper.setCropBoxData({ left: (container.width - cropWidth) / 2,
        top: (container.height - cropHeight) / 2, width: cropWidth, height: cropHeight });
    }
    positionLabels();
  }

  function positionLabels() {
    var wrap = byId('emaCropWrap'), crop = wrap.querySelector('.cropper-crop-box');
    if (!crop) return;
    var bounds = wrap.getBoundingClientRect(), box = crop.getBoundingClientRect();
    if (!box.width || !box.height) return;
    var horizontal = byId('emaRTop'), vertical = byId('emaRRight');
    horizontal.style.left = box.left - bounds.left + 'px'; horizontal.style.width = box.width + 'px';
    horizontal.style.top = Math.max(0, box.top - bounds.top - (horizontal.offsetHeight || 20)) + 'px';
    vertical.style.top = box.top - bounds.top + 'px'; vertical.style.height = box.height + 'px';
    vertical.style.left = Math.min(bounds.width - (vertical.offsetWidth || 20), box.right - bounds.left) + 'px';
  }

  async function addToCart() {
    if (state.busy) return;
    var result = sizing(state.width, state.height, state.unitPrice);
    if (!result.valid || !state.cropper || !state.available) { updatePrice(false); return; }
    state.busy = true;
    var previousText = addButton.innerHTML;
    addButton.disabled = true; addButton.textContent = 'Creating your mural…'; byId('emaErr').textContent = '';
    // Freeze the customer-approved configuration for this request.
    var selected = state.selected, width = state.width, height = state.height;
    var controls = Array.from(root.querySelectorAll('input, button')).map(function (element) {
      var previous = { element: element, disabled: element.disabled };
      element.disabled = true; return previous;
    });
    try {
      var crop = state.cropper.getData();
      var response = await fetch(root.dataset.cropEndpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ origin_url: byId('emaCropImg').src, product_id: state.productId,
          mirror_mode: byId('emaMirror').checked, crop_x: crop.x, crop_y: crop.y,
          crop_width: crop.width, crop_height: crop.height })
      });
      if (!response.ok) throw new Error('The mural image could not be processed. Please try again.');
      var output = await response.json();
      if (output.status !== 'success' || !output.image_url || new URL(output.image_url).protocol !== 'https:') {
        throw new Error('The mural image could not be processed. Please try again.');
      }
      var cartResponse = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selected, quantity: result.units, properties: {
          Width: dimension(width) + ' cm', Height: dimension(height) + ' cm', imageURL: output.image_url
        } })
      });
      var item = await cartResponse.json();
      if (!cartResponse.ok || item.status || !item.id) throw new Error('Your mural was not added to the cart. Please try again or contact info@muralora.com.');
      // Let Shopify process its cloned cart response and notify consent-aware app pixels before navigation.
      await new Promise(function (resolve) { window.setTimeout(resolve, 500); });
      window.location.assign('/cart');
    } catch (error) {
      byId('emaErr').textContent = error.message || 'Something went wrong. Please try again.';
      state.busy = false;
      controls.forEach(function (previous) { previous.element.disabled = previous.disabled; });
      addButton.innerHTML = previousText;
      addButton.disabled = !sizing(state.width, state.height, state.unitPrice).valid || !state.available || !state.cropper;
    }
  }
})();
